<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>
    <div class="sdev-systembar">

        <div class="sdev-systembar-status">

            <span v-if="navigationState.source === 'fallback'" class="sdev-systembar-indicator-unhealthy">
                Navigation in fallback mode
            </span>

            <span v-else class="sdev-systembar-indicator-healthy">
                System healthy
            </span>
        </div>

        <div class="sdev-systembar-tools">
            <button class="sdev-systembar-toggle" @click="toggle">
                ⚙
            </button>

        </div>

    </div>
</template>

<script setup>
import BedrockMonitor from "@/reflection/Core/BedrockMonitor.vue"
import { ref } from "vue"
import { navigationState } from "@/domain/navigation/navigation.state"

const open = ref(false)

function toggle() {
    open.value = !open.value
}

</script>